module.exports = __webpack_public_path__ + "static/media/astronaut.642d7efb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Basic/NotFound/astronaut.svg
// module id = 1045
// module chunks = 0